import { NodeData as QuizNodeData, MediaData as QuizMediaData } from './quiz';

export enum SpacedRepetitionState {
  UNSCHEDULED,
  SCHEDULED_FLAGGED,
  SCHEDULED,
}

export type QueueType = 'question' | 'flashcard' | 'spacedRepetition';

export type QuizQueueIndexData = {
  done: number[];
  todo: number[];
};

export type QuizQueueDetails = {
  byTag: {
    key: string;
    ids: {
      list: number[];
    };
  }[];
  index: {
    'just now'?: QuizQueueIndexData;
    today?: QuizQueueIndexData;
    'this week'?: QuizQueueIndexData;
    // TODO: the remaining keys
  };
};

export type QuizQueueQueryResponse = {
  flashcards?: QuizQueueDetails;
  questions?: QuizQueueDetails;
  spacedRepetition?: SpacedRepetitionQueues;
};

export type SpacedRepetitionQueues = {
  osmosis?: SpacedRepetitionDetails;
  local?: SpacedRepetitionDetails;
};

export type QuizSpacedRepetition = {
  age: number[];
  ids: number[];
};

export type SpacedRepetitionDetails = {
  completedToday: number[];
  correct: number;
  quiz: QuizSpacedRepetition;
  items: {
    age: number;
    nodeID: number;
  }[];
  name?: string;
};

export type QueueDataProps = {
  flashcards?: QuizQueueDetails;
  questions?: QuizQueueDetails;
  spacedRepetition?: SpacedRepetitionQueues;
};

export type QueueApiResponse = {
  queues?: {
    questions?: QuizQueueDetails;
    flashcards?: QuizQueueDetails;
    spacedRepetition?: {
      osmosis?: SpacedRepetitionDetails;
      local?: SpacedRepetitionDetails;
    };
  };
};

export enum QuizQueueActions {
  remove = 'remove',
  promote = 'promote',
  promoteNew = 'promoteNew',
  flag = 'flag',
  unflag = 'unflag',
}

export enum QuizQueuesTab {
  Flashcard,
  Question,
}

export type QuizQueueByItemFilter = {
  type: 'text';
  data: { value: string; unary: 'is' | 'not' };
};

export type QuizQueueByItemForm = {
  search: string;
  filters: {
    type: QuizQueueByItemFilter['type'];
    unary: QuizQueueByItemFilter['data']['unary'];
    value: QuizQueueByItemFilter['data']['value'];
  }[];
};

export type MediaData = {
  data: QuizMediaData;
  nodeID: number[];
  subtype: number[];
  type: number[];
};

export type NodeData = MediaData & {
  data: QuizNodeData[];
  flaggedOn: string[];
  repeatOn: (string | null)[];
  userID: number[];
  mediaData: QuizMediaData;
};

export type QuizQueueByItemParams = {
  type: 'fc' | 'ques';
  startRow: number;
  rowCount: number;
  filter: QuizQueueByItemFilter[];
};

export type QuizQueueByItemResponse = {
  rows: {
    nodeData: NodeData;
    mediaData: MediaData;
  };
  total: number;
};
